import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'appVersion',
  initialState: { updateAvailable: false },
  reducers: {
    setUpdateAvailable(state, action) { state.updateAvailable = action.payload; },
  }
});

export { actions as appVersionActions };
export { reducer as appVersionReducer };
